import { promos } from "$lib/models/promos";

let today = new Date(Date.now());
let utcNowDate = today.getUTCDate();
let setUtcDateNow = today.setUTCDate(utcNowDate);

let validDeals = promos.filter((promo) => {
    let initDate = new Date(Date.UTC(promo?.publish_date[0], promo?.publish_date[1], promo?.publish_date[2]));
    let utcPromoDate = initDate.getUTCDate();
    let setUTCpromoInitDate = initDate.setUTCDate(utcPromoDate);
    let endDate = new Date(Date.UTC(promo?.end_date[0], promo?.end_date[1], promo?.end_date[2]));
    let utcPromoEndDate = endDate.getUTCDate();
    let setUTCpromoEndDate = endDate.setUTCDate(utcPromoEndDate);
    if (setUTCpromoInitDate <= setUtcDateNow && setUTCpromoEndDate >= setUtcDateNow) {
        return promo;
    }
});

export const routes = [
    {
        summary: 'Shop',
        link: '/products',
        content: [
            {
                link: '/sale',
                main: 'Sale',
                childrens: validDeals.map(item => {
                    return {
                        link: item.link,
                        text: item.name,
                        image: {
                            img: item?.menu?.img,
                            img2x: item?.menu?.img,
                            img3x: item?.menu?.img,
                        },
                    }
                }),
            },
            {
                link: '/colors',
                main: 'Colors',
                childrens: [
                    {
                        link: '/colors/collections',
                        // image: {
                        //     img: "/images/collections/main_collection/spring-2025/21123-GELMT-SP25-Hand-Glam-Group-Gel-Photo-2.webp",
                        //     img2x: "/images/collections/main_collection/spring-2025/21123-GELMT-SP25-Hand-Glam-Group-Gel-Photo-2@2x.webp",
                        //     img3x: "/images/collections/main_collection/spring-2025/21123-GELMT-SP25-Hand-Glam-Group-Gel-Photo-2@2x.webp"
                        // },
                        video: "/videos/21053-GEL-SPRING-2025-Meet-The-Collection-Video-GEL-FNL 2_1.mp4",
                        text: 'COLLECTIONS',
                    },
                    {
                        link: '/colors/bundles',
                        image: {
                            img: "/images/menu/desktop/sale/16071-GELMT-CORE-LifestyleProd-Photo-Group2-Group3.webp",
                            img2x: "/images/menu/desktop/sale/16071-GELMT-CORE-LifestyleProd-Photo-Group2-Group3@2x.webp",
                            img3x: "/images/menu/desktop/sale/16071-GELMT-CORE-LifestyleProd-Photo-Group2-Group3@2x.webp"
                        },
                        text: 'COLOR BUNDLES',
                    },
                    {
                        link: '/colors/gelish',
                        image: {
                            img: '/images/menu/desktop/colors/search-all.webp',
                            img2x: '/images/menu/desktop/colors/search-all@2x.webp',
                            img3x: '/images/menu/desktop/colors/search-all@3x.webp',
                        },
                        text: 'SEARCH ALL',
                    },
                    {
                        link: '/colors/gelish/purple',
                        image: {
                            img: '/images/menu/desktop/colors/purple.webp',
                            img2x: '/images/menu/desktop/colors/purple@2x.webp',
                            img3x: '/images/menu/desktop/colors/purple@3x.webp',
                        },
                        text: 'PURPLE',
                    },
                    {
                        link: '/colors/gelish/pink',
                        image: {
                            img: '/images/menu/desktop/colors/pinks.webp',
                            img2x: '/images/menu/desktop/colors/pinks@2x.webp',
                            img3x: '/images/menu/desktop/colors/pinks@3x.webp',
                        },
                        text: 'PINK',
                    },
                    {
                        link: '/colors/gelish/red',
                        image: {
                            img: '/images/menu/desktop/colors/reds.webp',
                            img2x: '/images/menu/desktop/colors/reds@2x.webp',
                            img3x: '/images/menu/desktop/colors/reds@3x.webp',
                        },
                        text: 'RED',
                    },
                    {
                        link: '/colors/gelish/orange-coral',
                        image: {
                            img: '/images/menu/desktop/colors/corals.webp',
                            img2x: '/images/menu/desktop/colors/corals@2x.webp',
                            img3x: '/images/menu/desktop/colors/corals@3x.webp',
                        },
                        text: 'ORANGE & CORAL',
                    },
                    {
                        link: '/colors/gelish/green-blue',
                        image: {
                            img: '/images/menu/desktop/colors/blues.webp',
                            img2x: '/images/menu/desktop/colors/blues@2x.webp',
                            img3x: '/images/menu/desktop/colors/blues@3x.webp',
                        },
                        text: 'GREEN & BLUE',
                    },
                    {
                        link: '/colors/gelish/neutral',
                        image: {
                            img: '/images/menu/desktop/colors/neutral.webp',
                            img2x: '/images/menu/desktop/colors/neutral@2x.webp',
                            img3x: '/images/menu/desktop/colors/neutral@3x.webp',
                        },
                        text: 'NEUTRAL',
                    },
                    {
                        link: '/colors/gelish/glitter',
                        image: {
                            img: '/images/menu/desktop/colors/glitter.webp',
                            img2x: '/images/menu/desktop/colors/glitter@2x.webp',
                            img3x: '/images/menu/desktop/colors/glitter@3x.webp',
                        },
                        text: 'GLITTER',
                    },
                    {
                        link: '/colors/gelish/metallic',
                        image: {
                            img: '/images/menu/desktop/colors/metallic.webp',
                            img2x: '/images/menu/desktop/colors/metallic@2x.webp',
                            img3x: '/images/menu/desktop/colors/metallic@3x.webp',
                        },
                        text: 'METALLIC',
                    },
                ],
            },
            {
                link: '/soft-gel/short-round',
                main: 'SOFT GEL EXTENSIONS',
                childrens: [
                    {
                        link: '/soft-gel/short-round',
                        image: {
                            img: '/images/menu/desktop/softgel/softgel.webp',
                            img2x: '/images/menu/desktop/softgel/softgel@2x.webp',
                            img3x: '/images/menu/desktop/softgel/softgel@3x.webp',
                        },
                        text: 'TIPS',
                    },
                    {
                        link: '/soft-gel/short-round#neutral-tips',
                        image: {
                            img: '/images/menu/desktop/softgel/neutral_tips.webp',
                            img2x: '/images/menu/desktop/softgel/neutral_tips@2x.webp',
                            img3x: '/images/menu/desktop/softgel/neutral_tips@3x.webp',
                        },
                        text: 'NEUTRAL TIPS',
                    },
                    {
                        link: '/soft-gel/short-round#essentials',
                        image: {
                            img: '/images/menu/desktop/softgel/essentials.webp',
                            img2x: '/images/menu/desktop/softgel/essentials@2x.webp',
                            img3x: '/images/menu/desktop/softgel/essentials@3x.webp',
                        },
                        text: 'ESSENTIALS',
                    },
                    {
                        link: "/nail-lamps-tools/led-lamps",
                        image: {
                            img: '/images/menu/desktop/softgel/lights.webp',
                            img2x: '/images/menu/desktop/softgel/lights@2x.webp',
                            img3x: '/images/menu/desktop/softgel/lights@3x.webp',
                        },
                        text: 'LIGHTS',
                    },
                    {
                        link: '/soft-gel/short-round',
                        image: {
                            img: '/images/menu/desktop/softgel/short_round.webp',
                            img2x: '/images/menu/desktop/softgel/short_round@2x.webp',
                            img3x: '/images/menu/desktop/softgel/short_round@3x.webp',
                        },
                        text: 'SHORT ROUND',
                    },
                    {
                        link: '/soft-gel/medium-round',
                        image: {
                            img: '/images/menu/desktop/softgel/medium_round.webp',
                            img2x: '/images/menu/desktop/softgel/medium_round@2x.webp',
                            img3x: '/images/menu/desktop/softgel/medium_round@3x.webp',
                        },
                        text: 'MEDIUM ROUND',
                    },
                    {
                        link: '/soft-gel/medium-coffin',
                        image: {
                            img: '/images/menu/desktop/softgel/medium_coffin.webp',
                            img2x: '/images/menu/desktop/softgel/medium_coffin@2x.webp',
                            img3x: '/images/menu/desktop/softgel/medium_coffin@3x.webp',
                        },
                        text: 'MEDIUM COFFIN',
                    },
                    {
                        link: '/soft-gel/long-coffin',
                        image: {
                            img: '/images/menu/desktop/softgel/long_coffin.webp',
                            img2x: '/images/menu/desktop/softgel/long_coffin@2x.webp',
                            img3x: '/images/menu/desktop/softgel/long_coffin@3x.webp',
                        },
                        text: 'LONG COFFIN',
                    },
                    {
                        link: '/soft-gel/medium-square',
                        image: {
                            img: '/images/menu/desktop/softgel/medium_square.webp',
                            img2x: '/images/menu/desktop/softgel/medium_square@2x.webp',
                            img3x: '/images/menu/desktop/softgel/medium_square@3x.webp',
                        },
                        text: 'MEDIUM SQUARE',
                    },
                    {
                        link: '/soft-gel/stiletto-medium',
                        image: {
                            img: '/images/menu/desktop/softgel/medium_stilletto.webp',
                            img2x: '/images/menu/desktop/softgel/medium_stilletto@2x.webp',
                            img3x: '/images/menu/desktop/softgel/medium_stilletto@3x.webp',
                        },
                        text: 'MEDIUM STILETTO',
                    },
                ],
            },
            {
                link: '/gelish',
                main: 'Gel Nail Polish',
                childrens: [
                    {
                        link: '/colors/gelish',
                        image: {
                            img: '/images/menu/desktop/gelish/gel_colors.webp',
                            img2x: '/images/menu/desktop/gelish/gel_colors@2x.webp',
                            img3x: '/images/menu/desktop/gelish/gel_colors@3x.webp',
                        },
                        text: 'GEL COLORS',
                    },
                    {
                        link: '/gelish/cat-eye',
                        image: {
                            img: '/images/menu/desktop/gelish/cat_eye.webp',
                            img2x: '/images/menu/desktop/gelish/cat_eye@2x.webp',
                            img3x: '/images/menu/desktop/gelish/cat_eye@3x.webp',
                        },
                        text: 'CAT EYE',
                    },
                    {
                        link: '/gelish/flash-gels',
                        image: {
                            img: '/images/menu/desktop/gelish/flash_gels.webp',
                            img2x: '/images/menu/desktop/gelish/flash_gels@2x.webp',
                            img3x: '/images/menu/desktop/gelish/flash_gels@3x.webp',
                        },
                        text: 'FLASH GLAM GELS',
                    },
                    {
                        link: '/gelish#base-top',
                        image: {
                            img: '/images/menu/items/gelish/mate.webp',
                            img2x: '/images/menu/items/gelish/mate.webp',
                            img3x: '/images/menu/items/gelish/mate.webp',
                        },
                        text: 'BASE AND TOP COATS',
                    },
                    {
                        link: '/gelish#essentials',
                        image: {
                            img: '/images/menu/desktop/gelish/essentials.webp',
                            img2x: '/images/menu/desktop/gelish/essentials@2x.webp',
                            img3x: '/images/menu/desktop/gelish/essentials@3x.webp',
                        },
                        text: 'ESSENTIALS',
                    },
                ],
                seeMore: '/gelish',
            },
            {
                link: '/morgan-taylor',
                main: 'NAIL POLISH',
                childrens: [
                    {
                        link: '/colors/morgan-taylor',
                        image: {
                            img: '/images/menu/desktop/morgan_taylor/mt_colors.webp',
                            img2x: '/images/menu/desktop/morgan_taylor/mt_colors@2x.webp',
                            img3x: '/images/menu/desktop/morgan_taylor/mt_colors@3x.webp',
                        },
                        text: 'MORGAN TAYLOR COLORS',
                    },
                    {
                        link: '/morgan-taylor/naturals',
                        image: {
                            img: '/images/menu/desktop/morgan_taylor/mt_naturals.webp',
                            img2x: '/images/menu/desktop/morgan_taylor/mt_naturals@2x.webp',
                            img3x: '/images/menu/desktop/morgan_taylor/mt_naturals@3x.webp',
                        },
                        text: 'MORGAN TAYLOR NATURALS',
                    },
                    {
                        link: '/morgan-taylor#peel-off-glitter',
                        image: {
                            img: '/images/menu/desktop/morgan_taylor/peel_of_glitter.webp',
                            img2x: '/images/menu/desktop/morgan_taylor/peel_of_glitter@2x.webp',
                            img3x: '/images/menu/desktop/morgan_taylor/peel_of_glitter@3x.webp',
                        },
                        text: 'PEEL-OFF GLITTER',
                    },
                    {
                        link: '/morgan-taylor#base-top',
                        image: {
                            img: '/images/menu/desktop/morgan_taylor/top_base.webp',
                            img2x: '/images/menu/desktop/morgan_taylor/top_base@2x.webp',
                            img3x: '/images/menu/desktop/morgan_taylor/top_base@3x.webp',
                        },
                        text: 'BASE AND TOP COATS',
                    },
                    {
                        link: '/morgan-taylor#essentials',
                        image: {
                            img: '/images/menu/desktop/morgan_taylor/essentials.webp',
                            img2x: '/images/menu/desktop/morgan_taylor/essentials@2x.webp',
                            img3x: '/images/menu/desktop/morgan_taylor/essentials@3x.webp',
                        },
                        text: 'ESSENTIALS',
                    },
                ],
                seeMore: '/morgan-taylor',
            },
            {
                link: '/enhancements',
                main: 'ENHANCEMENTS',
                childrens: [
                    {
                        link: '/enhancements/xpress-dip-n-brush',
                        image: {
                            img: '/images/menu/desktop/extensions/xpress_dip@2x.webp',
                            img2x: '/images/menu/desktop/extensions/xpress_dip@2x.webp',
                            img3x: '/images/menu/desktop/extensions/xpress_dip@3x.webp',
                        },
                        text: 'DIP POWDER',
                    },
                    {
                        link: '/products/gelish-brush-on-builder-0-5-fl-oz-sc/1148021',
                        image: {
                            img: '/images/menu/desktop/extensions/gel_brush@2x.webp',
                            img2x: '/images/menu/desktop/extensions/gel_brush@2x.webp',
                            img3x: '/images/menu/desktop/extensions/gel_brush@3x.webp',
                        },
                        text: 'BRUSH-ON BUILDER',
                    },
                    {
                        link: '/enhancements/hard-gels',
                        image: {
                            img: '/images/menu/desktop/extensions/hard_gel@2x.webp',
                            img2x: '/images/menu/desktop/extensions/hard_gel@2x.webp',
                            img3x: '/images/menu/desktop/extensions/hard_gel@3x.webp',
                        },
                        text: 'HARD GELS',
                    },
                    {
                        link: '/enhancements/prohesion',
                        image: {
                            img: '/images/menu/desktop/extensions/prohesion@2x.webp',
                            img2x: '/images/menu/desktop/extensions/prohesion@2x.webp',
                            img3x: '/images/menu/desktop/extensions/prohesion@3x.webp',
                        },
                        text: 'ACRYLIC',
                    },
                    {
                        link: '/enhancements/polygel',
                        image: {
                            img: '/images/menu/desktop/extensions/polygel@2x.webp',
                            img2x: '/images/menu/desktop/extensions/polygel@2x.webp',
                            img3x: '/images/menu/desktop/extensions/polygel@3x.webp',
                        },
                        text: 'POLYGEL',
                    },
                ],
            },
            {
                link: '/nail-lamps-tools',
                main: 'NAIL LAMPS AND TOOLS',
                childrens: [
                    {
                        link: '/nail-lamps-tools/led-lamps',
                        image: {
                            img: '/images/menu/desktop/tools/lights@2x.webp',
                            img2x: '/images/menu/desktop/tools/lights@2x.webp',
                            img3x: '/images/menu/desktop/tools/lights@3x.webp',
                        },
                        text: 'LED LAMPS',
                    },
                    {
                        link: '/nail-lamps-tools/e-files',
                        image: {
                            img: '/images/menu/desktop/tools/e-file.webp',
                            img2x: '/images/menu/desktop/tools/e-file@2x.webp',
                            img3x: '/images/menu/desktop/tools/e-file@3x.webp',
                        },
                        text: 'E-FILES',
                    },
                    {
                        link: '/nail-lamps-tools/vortex',
                        image: {
                            img: '/images/menu/desktop/tools/vortex@2x.webp',
                            img2x: '/images/menu/desktop/tools/vortex@2x.webp',
                            img3x: '/images/menu/desktop/tools/vortex@3x.webp',
                        },
                        text: 'NAIL DUST COLLECTOR',
                    },
                    {
                        link: '/nail-lamps-tools/brushes-and-tools',
                        image: {
                            img: '/images/menu/desktop/tools/nail_tools@2x.webp',
                            img2x: '/images/menu/desktop/tools/nail_tools@2x.webp',
                            img3x: '/images/menu/desktop/tools/nail_tools@3x.webp',
                        },
                        text: 'BRUSHES AND TOOLS',
                    },
                ],
                seeMore: '/nail-lamps-tools',
            },
            {
                link: '/nail-care',
                main: 'NAIL CARE',
                childrens: [
                    {
                        link: '/nail-care/bare-luxury',
                        image: {
                            img: '/images/menu/desktop/nail-care/bare_luxury.webp',
                            img2x: '/images/menu/desktop/nail-care/bare_luxury@2x.webp',
                            img3x: '/images/menu/desktop/nail-care/bare_luxury@3x.webp',
                        },
                        text: 'MANI AND PEDI',
                    },
                    {
                        link: '/nail-care',
                        image: {
                            img: '/images/menu/desktop/nail-care/daily_elixir.webp',
                            img2x: '/images/menu/desktop/nail-care/daily_elixir@2x.webp',
                            img3x: '/images/menu/desktop/nail-care/daily_elixir@3x.webp',
                        },
                        text: 'NAIL STRENGTHENERS',
                    },
                ],
            },
            {
                link: '/nail-arts',
                main: 'Nail Art',
                childrens: [
                    {
                        link: '/nail-arts/cream-gel',
                        image: {
                            img: '/images/menu/desktop/nail_arts/19774-GEL-CreamGel-Hand-Photo-PrettyPastels-Periwinkle6.webp',
                            img2x: '/images/menu/desktop/nail_arts/19774-GEL-CreamGel-Hand-Photo-PrettyPastels-Periwinkle6@2x.webp',
                            img3x: '/images/menu/desktop/nail_arts/19774-GEL-CreamGel-Hand-Photo-PrettyPastels-Periwinkle6@3x.webp',
                        },
                        text: 'SOLID CREAM <br/> GEL POLISH',
                    },
                    {
                        link: '/nail-arts#blooming-gel',
                        image: {
                            img: '/images/menu/desktop/nail_arts/blooming@2x.webp',
                            img2x: '/images/menu/desktop/nail_arts/blooming@2x.webp',
                            img3x: '/images/menu/desktop/nail_arts/blooming@3x.webp',
                        },
                        text: 'BLOOMING GEL',
                    },
                    {
                        link: '/nail-arts#chrome-stix',
                        image: {
                            img: '/images/menu/desktop/nail_arts/chrome_stix@2x.webp',
                            img2x: '/images/menu/desktop/nail_arts/chrome_stix@2x.webp',
                            img3x: '/images/menu/desktop/nail_arts/chrome_stix@3x.webp',
                        },
                        text: 'CHROME STIX',
                    },
                    {
                        link: '/nail-arts#art-forms',
                        image: {
                            img: '/images/menu/desktop/nail_arts/artforms@2x.webp',
                            img2x: '/images/menu/desktop/nail_arts/artforms@2x.webp',
                            img3x: '/images/menu/desktop/nail_arts/artforms@3x.webp',
                        },
                        text: 'ART FORM GELS',
                    },
                    {
                        link: '/nail-arts#foil-gel',
                        image: {
                            img: '/videos/foil_gel.gif',
                            img2x: '/videos/foil_gel.gif',
                            img3x: '/videos/foil_gel.gif',
                        },
                        text: 'NO LIGHT FOIL GEL',
                    },
                ],
            },
        ],
    },
    {
        summary: 'New',
        link: '/new',
        content: [{
            link: '/new',
            main: 'NEW PRODUCTS',
            childrens: [
                {
                    link: '/colors/collections/spring-2025',
                    video: "/videos/21053-GEL-SPRING-2025-Meet-The-Collection-Video-GEL-FNL 2_1.mp4",
                    text: 'NEW COLLECTION',
                },
                {
                    link: '/colors/bundles',
                    image: {
                        img: "/images/menu/desktop/sale/16071-GELMT-CORE-LifestyleProd-Photo-Group2-Group3.webp",
                        img2x: "/images/menu/desktop/sale/16071-GELMT-CORE-LifestyleProd-Photo-Group2-Group3@2x.webp",
                        img3x: "/images/menu/desktop/sale/16071-GELMT-CORE-LifestyleProd-Photo-Group2-Group3@2x.webp"
                    },
                    text: 'NEW BUNDLES',
                },
                {
                    link: '/nail-arts/cream-gel',
                    image: {
                        img: "/images/menu/desktop/nail_arts/19774-GEL-CreamGel-Hand-Photo-PrettyPastels-Periwinkle6.webp",
                        img2x: "/images/menu/desktop/nail_arts/19774-GEL-CreamGel-Hand-Photo-PrettyPastels-Periwinkle6@2x.webp",
                        img3x: "/images/menu/desktop/nail_arts/19774-GEL-CreamGel-Hand-Photo-PrettyPastels-Periwinkle6@3x.webp"
                    },
                    text: 'CREAM GEL',
                },
                {
                    link: '/gelish/cat-eye',
                    image: {
                        img: "/images/gelish/new_cat_eye/duo_chromatic_4.webp",
                        img2x: "/images/gelish/new_cat_eye/duo_chromatic_4@2x.webp",
                        img3x: "/images/gelish/new_cat_eye/duo_chromatic_4@3x.webp"
                    },
                    text: 'CAT EYE',
                },
                {
                    link: '/gelish/flash-gels',
                    image: {
                        img: "/images/menu/desktop/gelish/flash_gels.webp",
                        img2x: "/images/menu/desktop/gelish/flash_gels@2x.webp",
                        img3x: "/images/menu/desktop/gelish/flash_gels@2x.webp"
                    },
                    text: 'FLASH GELS',
                },
                {
                    link: "/enhancements/prohesion",
                    image: {
                        img: "/images/no-spill/prohesion.webp",
                        img2x: "/images/no-spill/prohesion@2x.webp",
                        img3x: "/images/no-spill/prohesion@3x.webp",
                    },
                    text: "PROHESION NO SPILL"
                },
                {
                    link: "/enhancements/xpress-dip-n-brush",
                    image: {
                        img: "/images/new/19519-GELMT-CORE-SumTheme-ProdGlam-NoSpill-Photo-3.webp",
                        img2x: "/images/new/19519-GELMT-CORE-SumTheme-ProdGlam-NoSpill-Photo-3@2x.webp",
                        img3x: "/images/new/19519-GELMT-CORE-SumTheme-ProdGlam-NoSpill-Photo-3@3x.webp",
                    },
                    text: "XPRESS DIP N BRUSH NO SPILL"
                },
                {
                    link: "/enhancements/xpress-dip-n-brush",
                    image: {
                        img: "/images/menu/desktop/morgan_taylor/mt_naturals.webp",
                        img2x: "/images/menu/desktop/morgan_taylor/mt_naturals@2x.webp",
                        img3x: "/images/menu/desktop/morgan_taylor/mt_naturals@3x.webp",
                    },
                    text: "MORGAN TAYLOR NATURALS"
                },
                {
                    link: "/nail-arts#foil-gel",
                    image: {
                        img: "/images/menu/desktop/nail_arts/foil_gel.webp",
                        img2x: "/images/menu/desktop/nail_arts/foil_gel@2X.webp",
                        img3x: "/images/menu/desktop/nail_arts/foil_gel@3x.webp",
                    },
                    text: "TRANSFER FOIL GEL"
                },
                {
                    link: "/products/gelish-mini-on-the-go-electric-nail-file/1168241",
                    image: {
                        img: "images/e-file/on_the_go.webp",
                        img2x: "images/e-file/on_the_go@2x.webp",
                        img3x: "images/e-file/on_the_go@3x.webp",
                    },
                    text: "ON THE GO PORTABLE E-FILE"
                },

            ],
        },
        ],
    },
    {
        summary: 'Best Sellers',
        link: '/best-sellers'
    },
    {
        summary: 'Blog',
        link: '/nail-style-blog'
    },
    {
        summary: 'Learn More',
        link: '/learn-more',
        content: [
            {
                link: '/learn-more',
                main: 'VIRTUAL CONTENT',
                childrens: [
                    {
                        link: "/virtual-salon",
                        image: {
                            img: "/images/menu/desktop/morgan_taylor/care_products.webp",
                            img2x: "/images/menu/desktop/morgan_taylor/care_products@2x.webp",
                            img3x: "/images/menu/desktop/morgan_taylor/care_products@3x.webp"
                        },
                        text: "VIRTUAL SALON"
                    },
                    {
                        link: '/videos',
                        image: {
                            img: "/images/menu/items/gelish/accessories.webp",
                            img2x: "/images/menu/items/gelish/accessories.webp",
                            img3x: "/images/menu/items/gelish/accessories.webp"
                        },
                        text: 'VIDEOS',
                    },
                ],
            },
            // {
            //     link: '/step-by-steps',
            //     main: 'STEP BY STEPS',
            //     childrens: [
            //         {
            //             link: "/step-by-steps/gelish",
            //             image: {
            //                 img: "/images/menu/desktop/morgan_taylor/care_products.webp",
            //                 img2x: "/images/menu/desktop/morgan_taylor/care_products@2x.webp",
            //                 img3x: "/images/menu/desktop/morgan_taylor/care_products@3x.webp"
            //             },
            //             text: "GELISH"
            //         },
            //         {
            //             link: "/step-by-steps/gelish",
            //             image: {
            //                 img: "/images/menu/desktop/morgan_taylor/care_products.webp",
            //                 img2x: "/images/menu/desktop/morgan_taylor/care_products@2x.webp",
            //                 img3x: "/images/menu/desktop/morgan_taylor/care_products@3x.webp"
            //             },
            //             text: "GELISH"
            //         }, {
            //             link: "/step-by-steps/gelish",
            //             image: {
            //                 img: "/images/menu/desktop/morgan_taylor/care_products.webp",
            //                 img2x: "/images/menu/desktop/morgan_taylor/care_products@2x.webp",
            //                 img3x: "/images/menu/desktop/morgan_taylor/care_products@3x.webp"
            //             },
            //             text: "GELISH"
            //         }, {
            //             link: "/step-by-steps/gelish",
            //             image: {
            //                 img: "/images/menu/desktop/morgan_taylor/care_products.webp",
            //                 img2x: "/images/menu/desktop/morgan_taylor/care_products@2x.webp",
            //                 img3x: "/images/menu/desktop/morgan_taylor/care_products@3x.webp"
            //             },
            //             text: "GELISH"
            //         }, {
            //             link: "/step-by-steps/gelish",
            //             image: {
            //                 img: "/images/menu/desktop/morgan_taylor/care_products.webp",
            //                 img2x: "/images/menu/desktop/morgan_taylor/care_products@2x.webp",
            //                 img3x: "/images/menu/desktop/morgan_taylor/care_products@3x.webp"
            //             },
            //             text: "GELISH"
            //         }, {
            //             link: "/step-by-steps/gelish",
            //             image: {
            //                 img: "/images/menu/desktop/morgan_taylor/care_products.webp",
            //                 img2x: "/images/menu/desktop/morgan_taylor/care_products@2x.webp",
            //                 img3x: "/images/menu/desktop/morgan_taylor/care_products@3x.webp"
            //             },
            //             text: "GELISH"
            //         }, {
            //             link: "/step-by-steps/gelish",
            //             image: {
            //                 img: "/images/menu/desktop/morgan_taylor/care_products.webp",
            //                 img2x: "/images/menu/desktop/morgan_taylor/care_products@2x.webp",
            //                 img3x: "/images/menu/desktop/morgan_taylor/care_products@3x.webp"
            //             },
            //             text: "GELISH"
            //         },
            //     ],
            // },

        ]
    },
]

export let collections = [
    '/colors/collections/winter-2023',
    '/colors/collections/fall-2023',
    '/colors/collections/summer-2023',
    '/colors/collections/spring-2023',
    '/colors/collections/fall-2022',
    '/colors/collections/summer-2022',
    '/colors/collections/spring-2022',
    '/colors/collections/fall-2021',
    '/colors/collections/summer-2021',
    '/colors/collections/spring-2021',
]